import EffectMechanic from '@/roc/effects/EffectMechanic';
import AbstractProduction from '@/roc/effects/Production/AbstractProduction';
class ProductionQueue extends AbstractProduction {
    __workers;
    __cost;
    constructor(workers, cost, duration, output) {
        super(EffectMechanic.PRODUCTION_QUEUE, duration, output);
        this.__workers = workers;
        this.__cost = cost;
    }
    clone(workers = null, cost = null, duration = null, output = null) {
        return new ProductionQueue(workers || this.__workers, cost || this.__cost, duration || this.__duration, output || this.__output);
    }
}
export default ProductionQueue;
